import { AnyErrorPage } from "./AnyErrorPage";
import { DataNotFoundErrorPage } from "./DataNotFoundErrorPage";
import { NotAllowedErrorPage } from "./NotAllowedErrorPage";

export const ErrorPage = {
  Any: AnyErrorPage,
  NotAllowed: NotAllowedErrorPage,
  DataNotFound: DataNotFoundErrorPage,
};
